import { Group, Text, UnstyledButton } from "@mantine/core";
import type { ReactNode } from "react";

import classes from "./ContentCard.module.css";

/** Renders the card's link: the page passes its router Link, as `renderRoot` takes it. */
export type CardLink = (props: Record<string, unknown>) => ReactNode;

export interface ContentCardProps {
  /** The picture in the 1.39:1 box: a brand's logo. */
  media: ReactNode;
  title: string;
  description?: string;
  /** Where the picture and the title lead. */
  link: CardLink;
  /** Footer left: a brand's color swatches. */
  footer?: ReactNode;
  /** Footer right, shown on hover: edit and delete. */
  actions?: ReactNode;
  /** The brand the URL is on. */
  active?: boolean;
}

/**
 * A card of the brands grid (design-system.md 3.6): the picture in a soft box that grows on
 * hover, a one-line title that turns primary, a one-line description, and a footer whose actions
 * fade in on hover. The active card has a primary border.
 */
export function ContentCard(props: ContentCardProps) {
  const { media, title, description, link, footer, actions, active = false } = props;
  return (
    <article className={classes.card} data-active={active || undefined}>
      <UnstyledButton renderRoot={link} className={classes.open}>
        <div className={classes.media}>{media}</div>
        <Text lineClamp={1} className={classes.title}>
          {title}
        </Text>
      </UnstyledButton>
      <Text lineClamp={1} className={classes.description}>
        {description ?? ""}
      </Text>
      <Group justify="space-between" wrap="nowrap" mt="auto">
        <div>{footer}</div>
        {actions === undefined ? null : <div className={classes.actions}>{actions}</div>}
      </Group>
    </article>
  );
}
